import { Component } from '@angular/core';
import { SearchBaseCardComponent } from '../search-base-card.component';

@Component({
  selector: 'app-search-organization-card',
  standalone: false,
  
  templateUrl: './search-organization-card.component.html',
  styleUrl: './search-organization-card.component.scss'
})
export class SearchOrganizationCardComponent extends SearchBaseCardComponent {

}
